import { accentFold } from './accentFold';

// @odeniel @param "lowerCase" deprecated
export function clean(str = '', { caseSensitive = false, lowerCase, accentFolding = true } = {}) {
  if (typeof str === 'number') {
    str += '';
  }
  if (typeof str !== 'string') {
    str = '';
  } // @odeniel estaría bien tratar object/null, array, boolean,... (ya estan string, number, undefined)
  if (!caseSensitive || lowerCase) {
    str = str.toLowerCase();
  }
  if (accentFolding) {
    str = accentFold(str);
  }
  return str;
}
